export default {
  namespaced: true,

  state: {
    isLoading: true,
    hasData: false,
    hasDetails: false,
    hasObjects: false,
    list: [],
    active: [],
    updateKey: 0,
    selected: [],
    renewKey: 0,
    updateObjectKey: 0,
    path: false,
    objectsLoading: false,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    OBJECTS_LOADING(state, bool) {
      state.objectsLoading = bool;
    },

    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    HAS_OBJECTS(state, bool) {
      state.hasObjects = bool;
    },

    SET(state, objectStore) {
      state.list = objectStore;
    },

    SET_ACTIVE(state, services) {
      state.active = services;
    },

    ADD(state, objectStore) {
      state.list.push(objectStore);
    },

    SET_CURRENT(state, objectStore) {
      state.current = objectStore;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE_OBJECTS_KEY(state) {
      state.updateObjectKey += 1;
    },

    RENEW_DETAILS(state) {
      state.renewKey += 1;
    },

    RENEW(state, objectStore) {
      state.list = objectStore;
    },

    UPDATE(state, objectStore) {
        const item = state.list.find(item => item.name === objectStore.name && item.region === objectStore.region);
        Object.assign(item, objectStore);
    },

    SET_OBJECTS(state, objects) {
        const item = state.list.find(item => item.name === objects.name && item.region === objects.region);
        item.objects = [];
        Object.assign(item.objects, objects);
    },

    PATH(state, path) {
      state.path = path;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },
  },

  actions: {
    SET(context, objectStore) {
      context.commit('SET', objectStore);
    },

    ADD(context, objectStore) {
      context.commit('ADD', objectStore);
    },

    RENEW(context, objectStore) {
      context.commit('RENEW', objectStore);
    },

    SET_CURRENT(context, objectStore) {
      context.commit('SET_CURRENT', objectStore);
    },

    SET_SELECTED(context, resources) {
      context.commit('SET_SELECTED', resources);
    },
  }
}
